export const USER_SETTINGS_TABS_ID = {
	TIER: 'tier',
	OFFICE_GROUP: 'office_group',
	COLORS_WEBSITE: 'colors_website',
	COLORS_ITEM: 'colors_item',
    SITE_GROUP: 'sites_group',
	WEB_SUPPLIER_GROUP: 'web_supplier_group',
}